export default __webpack_public_path__ + "static/media/JaguarFavicon.8a34fe0f.svg";